/**
 * useUsageAllowance — the caller's monthly usage allowances (BeHeard's LOCAL
 * NONCOMMERCIAL SAFETY LIMIT pools) from GET /billing/status.
 *
 * Replaces useCredits, which read fields the server never sent and defaulted
 * them to 0 — so paying users saw "No Listening Credits Remaining", a disabled
 * "Play Full" and "AI Voice Coach (0 credits)". Here unknown is 'unavailable'
 * and nothing is for gating: the server decides admission (see
 * utils/billingStatusView.ts).
 */
import { useGetBillingStatusQuery } from '../store/api/billingApi';
import { allowanceView, type AllowanceView } from '../utils/billingStatusView';

export interface UsageAllowanceInfo {
  listen: AllowanceView;
  coaching: AllowanceView;
  practice: AllowanceView;
  isLoading: boolean;
  isError: boolean;
  refetch: () => void;
}

export function useUsageAllowance(options: { skip?: boolean } = {}): UsageAllowanceInfo {
  const { data, isLoading, isError, refetch } = useGetBillingStatusQuery(undefined, { skip: options.skip });
  const q = { isLoading, isError };
  return {
    listen: allowanceView(data, 'listen', q),
    coaching: allowanceView(data, 'coaching', q),
    practice: allowanceView(data, 'practice', q),
    isLoading,
    isError,
    refetch,
  };
}
